import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import { useSelectedReturnExchangesActionsContextHook, useSelectedReturnExchangesValueContextHook } from "../../../../contexts/SelectedReturnExchangesContext";
import styled from 'styled-components';
import { useStoreInfosValueContextHook } from "../../../../contexts/StoreInfosContext";
import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { useApiInfoContextValueHook } from "../../../../../../../contexts/ApiInfoContext";
import { useFetcher } from "../../../../fetcher/useFetcher";
import { customToast } from "../../../../../../../components/toast/custom-react-toastify/v1";
import { SellertoolSignatureUtils } from "../../../../../../../utils/sellertool-signature-utils";
import { CustomBackdropController } from "../../../../../../../components/backdrop/default/v1";
import { ReturnExchangesApi } from "../../../../../../../apis/ReturnExchangesApi";
import { useState } from "react";
import { CommerceApiApi } from "../../../../../../../apis/CommerceApiApi";
import _ from "lodash";
import { CoupangApiApi } from "../../../../../../../apis/CoupangApiApi";
import { deliveryCompanyCodes } from "../../../../../variables/delivery-company-codes";

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    
    .items{
        display: flex;
        flex-direction: column;
        gap: 10px;

        .item{
            font-size: 12px;
            padding: 10px;
            border: 1px solid #e0e0e0;
            border-radius: 3px;
            
            &.success{
                border-color: var(--greenColor1);
            }

            &.fail{
                border-color: var(--redColor1);
            }

            .flexible{
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 10px;
            }

            .errorMessage{
                margin-top: 10px;
                color: var(--redColor1);
                font-weight: 600;
            }

            .success{
                margin-top: 10px;
                color: var(--greenColor1);
                font-weight: 600;
            }
        }
    }
`;

const StyledFooter = styled.div`
    padding: 10px;

    button{
        background: #333;
        color: #fff;
        border:none;
        font-weight: 600;
        border-radius: 3px;
    }
`;
export function ModalExchangeConfirm({
    open,
    onClose,
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();
    const selectedReturnExchangesActionsContextHook = useSelectedReturnExchangesActionsContextHook();
    const selectedReturnExchangesValueContextHook = useSelectedReturnExchangesValueContextHook();
    const storeInfosValueContextHook = useStoreInfosValueContextHook();
    const selectedReturnExchanges = selectedReturnExchangesValueContextHook.selectedReturnExchanges;
    const storeInfos = storeInfosValueContextHook.storeInfos;
    const [confirmResults, setConfirmResults] = useState([]);

    const handleSubmit = async () => {
        setConfirmResults([]);
        if (!selectedReturnExchangesValueContextHook?.selectedReturnExchanges || selectedReturnExchangesValueContextHook?.selectedReturnExchanges.length === 0) {
            customToast.error('선택된 교환 반품건이 없습니다.');
            return;
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        let body = {};
        CustomBackdropController().showBackdrop();
        for (let i = 0; i < selectedReturnExchangesValueContextHook?.selectedReturnExchanges.length; i++) {
            const returnExchange = selectedReturnExchangesValueContextHook?.selectedReturnExchanges[i];
            const storeInfo = storeInfos.find((storeInfo) => storeInfo.id === returnExchange?.salesChannelMatchingStoreId);

            // 택배사 코드가 없는 경우
            if(!returnExchange?.exchangeReShipmentDeliveryCompanyCode){
                setConfirmResults(prev => {
                    return [
                        ...prev,
                        {
                            _id: returnExchange?._id,
                            status: 'ERROR',
                            orderNumber1: returnExchange?.orderNumber1,
                            message: '택배사를 선택해주세요.'
                        }
                    ]
                })
                continue;
            }

            // 운송장번호가 없는 경우
            if(!returnExchange?.exchangeReShipmentWaybillNumber){
                setConfirmResults(prev => {
                    return [
                        ...prev,
                        {
                            _id: returnExchange?._id,
                            status: 'ERROR',
                            orderNumber1: returnExchange?.orderNumber1,
                            message: '운송장번호를 입력해주세요.'
                        }
                    ]
                }
                )
                continue;
            }

            switch (storeInfo?.storeType) {
                case 'COMMERCE_API':
                    body = {
                        formData: returnExchange,
                    }

                    const response = await CommerceApiApi().exchangeConfirmOrder({ headers, body });
                    if (response?.content) {
                        setConfirmResults(prev => {
                            return [
                                ...prev,
                                response?.content
                            ]
                        })
                    } else {
                        setConfirmResults(prev => {
                            return [
                                ...prev,
                                {
                                    _id: returnExchange?._id,
                                    status: 'ERROR',
                                    orderNumber1: returnExchange?.orderNumber1,
                                    message: response?.message
                                }
                            ]
                        })
                    }
                    break;
                case 'COUPANG_API':
                    body = {
                        formData: returnExchange,
                    }
                    const coupangResponse = await CoupangApiApi().exchangeConfirmOrder({ headers, body });
                    if (coupangResponse?.content) {
                        setConfirmResults(prev => {
                            return [
                                ...prev,
                                coupangResponse?.content
                            ]
                        })
                    } else {
                        setConfirmResults(prev => {
                            return [
                                ...prev,
                                {
                                    _id: returnExchange?._id,
                                    status: 'ERROR',
                                    orderNumber1: returnExchange?.orderNumber1,
                                    message: coupangResponse?.message
                                }
                            ]
                        })
                    }
                    break;
                default: break;
            }

            await new Promise((res) => setTimeout(res, 1000));
        }

        CustomBackdropController().hideBackdrop();
    }

    const handleChangeReturnExchanges = async () => {
        // returnConfirmResults의 status가 SUCCESS인 것들의 _id를 가져온다.
        const successIds = confirmResults.filter(result => result.status === 'SUCCESS').map(result => result._id);
        let targetReturnExchanges = _.cloneDeep(selectedReturnExchanges.filter(returnExchange => successIds.includes(returnExchange._id)));

        targetReturnExchanges = targetReturnExchanges.map(returnExchange => {
            return {
                ...returnExchange,
                returnExchangeProceedStatus: 'EXCHANGE_RE_SHIPMENT_COMPLETE',
                exchangeReShipmentAt: new Date().toISOString()
            }
        });

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().updateList({
            headers: headers,
            body: {
                returnExchanges: targetReturnExchanges
            }
        });

        if (response?.content) {
            await fetcher.fetchReturnExchanges();
            setConfirmResults([]);
            selectedReturnExchangesActionsContextHook.selectedReturnExchanges.setValue(prev => {
                return prev?.filter(r => !successIds.includes(r._id));
            })
        }
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <CustomDialog
                open={open}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            교환 재배송
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <div className='items'>
                        {selectedReturnExchanges?.map((returnExchange) => {
                            const storeInfo = storeInfos.find((storeInfo) => storeInfo.id === returnExchange?.salesChannelMatchingStoreId);
                            const returnConfirmResult = confirmResults?.find((result) => result._id === returnExchange?._id);
                            const deliveryCompany = deliveryCompanyCodes?.find(r => r.code === returnExchange?.exchangeReShipmentDeliveryCompanyCode);
                            return (
                                <div key={returnExchange?._id} className={`item ${returnConfirmResult?.status === 'SUCCESS' ? 'success' : (returnConfirmResult?.status === 'FAIL' || returnConfirmResult?.status === 'ERROR') ? 'fail' : ''}`}>
                                    <div className='flexible'>
                                        <div>주문번호 : {returnExchange?.orderNumber1}</div>
                                        <div>스토어 : {storeInfo?.storeName ? storeInfo?.storeName : '-'}</div>
                                    </div>
                                    <div className='flexible'>
                                        <div>택배사 : {deliveryCompany?.name || '-'}</div>
                                        <div>재배송 운송장 : {returnExchange?.exchangeReShipmentWaybillNumber || '-'}</div>
                                    </div>
                                    {returnConfirmResult?.status === 'SUCCESS' &&
                                        <div className='success'>
                                            성공적으로 반품 승인 처리되었습니다.
                                        </div>
                                    }
                                    {(returnConfirmResult?.status === 'FAIL' || returnConfirmResult?.status === 'ERROR') &&
                                        <div className='errorMessage'>
                                            에러메시지 : {returnConfirmResult?.message}
                                        </div>
                                    }
                                </div>
                            );
                        })}
                    </div>
                </StyledBody>
                <StyledFooter>
                    {confirmResults?.length > 0 ?
                        <CustomBlockButton
                            type='button'
                            onClick={handleChangeReturnExchanges}
                        >
                            완료건 진행상태를 교환재출고완료로 변경
                        </CustomBlockButton>
                        :
                        <CustomBlockButton
                            type='button'
                            onClick={handleSubmit}
                        >
                            교환 재배송
                        </CustomBlockButton>
                    }
                </StyledFooter>
            </CustomDialog>
        </>
    );
}